export default "/images/phone-forwarded.svg?e968ad4daf77b46419a0afd194bae823";